export const networking = {
  'QrBadge': 'QR Badge',
  'seeAll': 'Alles weergeven',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Bekijk ze!',
  'topicsToDiscuss': 'Onderwerpen om te bespreken',
  'OneOnOneMeet': '1-op-1 Ontmoeting',
  'learnMoreNetworking': 'Leer meer over Networking Hub',
  'scanQrCode': 'Scan QR-code',
  'message': 'Bericht',
  'myBadge': 'Mijn badge',
  'scannedBadge': 'Gescreende badge',
  'viewProfile': 'Bekijk profiel',
  'userRatingDetails': 'Gebruikersbeoordelingsdetails',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Totale score:',
  'scoreComposedOf': 'Deze score is opgebouwd uit:',
  'confirmationText': 'Weet je het zeker? Dit kan niet ongedaan worden gemaakt.',

  'welcomeMessage': 'Welkom bij de <strong>Networking Hub</strong>, waar verbindingen tot leven komen! Hier is hoe het werkt:',
  'connectingMadeSimpleTitle': 'Eenvoudig verbinden',
  'connectingMadeSimpleDescription': 'De Networking Hub biedt gestructureerde activiteiten en niveaus om je effectief te verbinden:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Verken profielen van nieuwkomers, voeg interessante toe aan je shortlist en stuur berichten. Je kunt zelfs persoonlijk met hen verbinden.',
  'shortlistDescription':
    '<strong>Shortlist:</strong> Zodra je interesse toont in iemand, wordt die persoon aan je shortlist toegevoegd.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> Wanneer je contact opneemt en een reactie ontvangt, worden ze naar deze categorieën verplaatst.',
  'skipDescription': '<strong>Skip:</strong> Geen interesse? Sla het profiel eenvoudig over en ga verder!',

  'enhancedNetworkingActivitiesTitle': 'Verbeterde netwerkactiviteiten',
  'enhancedNetworkingActivitiesDescription': 'Naast directe verbindingen bevat de Hub:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Verken onderwerpen die je interesseren en verbind met auteurs of deelnemers. Doe mee aan online discussies of plan groepsvergaderingen om dieper in deze onderwerpen te duiken.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Beheer vergaderverzoeken, volg geplande vergaderingen en organiseer je schema moeiteloos.',

  'gamificationTitle': 'Gamificatie voor plezier en betrokkenheid',
  'gamificationDescription':
    'Verhoog je activiteit met een leaderboard dat je punten bijhoudt en de meest actieve netwerkers toont. Zo kun je punten verdienen:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1.000 punten:</strong> Vul je profiel in (inclusief foto).',
    points1000PushNotifications: '<strong>1.000 punten:</strong> Zet pushmeldingen aan.',
    points100SendMeetingRequest: '<strong>100 punten:</strong> Stuur een 1-op-1 vergaderverzoek.',
    points400GetAcceptedRequest: '<strong>400 punten:</strong> Krijg je 1-op-1 verzoek geaccepteerd.',
    points400AcceptRequest: '<strong>400 punten:</strong> Accepteer een 1-op-1 verzoek.',
    points100DeclineRequest: '<strong>100 punten:</strong> Weiger een 1-op-1 verzoek.',
    points400CreateDiscussion: '<strong>400 punten:</strong> Maak een discussieonderwerp.',
    points50LikeDiscussion: '<strong>50 punten:</strong> Like een discussieonderwerp.',
    points200PostFirstComment: '<strong>200 punten:</strong> Telkens wanneer je je eerste reactie plaatst op een ander onderwerp.',
    points100LikeOnTopic: '<strong>100 punten:</strong> Verdien een like op je onderwerp.',
    points200UniqueCommenter: '<strong>200 punten:</strong> Krijg een unieke reactie op je onderwerp.',
    points100LikeShortlistUser: '<strong>100 punten:</strong> Like/voeg een gebruiker toe aan je shortlist.',
    points50SkipUser: '<strong>50 punten:</strong> Sla een gebruiker over.',
    points200StartChat: '<strong>200 punten:</strong> Begin een chat (gecontacteerd).',
    points300GetChatResponse: '<strong>300 punten:</strong> Krijg een reactie in een chat (verbonden).',
    points400RespondToChat: '<strong>400 punten:</strong> Reageer op een chatverzoek (verbonden).',
    points500SpeedNetworking: '<strong>500 punten:</strong> Voor elke speednetworking-sessie.'
  },

  'finalMessage':
    'Haal het meeste uit de Networking Hub, ontdek nieuwe kansen en klim op het leaderboard terwijl je verbinding maakt en betrokken raakt bij gelijkgestemde professionals!',

  'manageMeeting': 'Vergadering beheren',
  'addToCalendar': 'Toevoegen aan agenda',
  'cancel': 'Annuleren',
  'accept': 'Accepteren',
  'accept&addToCalendar': 'Accepteren en toevoegen aan agenda',
  'editDetails': 'Details bewerken',
  'reject': 'Weigeren',
  'delete': 'Verwijderen',
  'exportContact': 'Contact exporteren',
  'scheduleNewOneOnOne': 'Nieuwe 1-op-1 plannen',
  'initiatedBy': 'Geïnitieerd door',
  'rejectedBy': 'Afgewezen door',
  'you': 'jij',
  'meetPassed': 'De vergadering is voorbij',
  'meetInProgress': 'Bezig',

  'myOneOnOne': 'Mijn 1:1',

  'speed': {
    history: 'Geschiedenis',
    minutes: 'min.',
    users_available: 'gebruikers',
    rules: 'Regels',
    activate: 'Activeren',
    matching: 'Matchen...',
    start: 'Start',
    find_a_user: 'Zoek een gebruiker met dezelfde afbeelding',
    find_a_user_number: 'Zoek een gebruiker met hetzelfde nummer',
    waiting: 'Wachten...',
    speaking_now: 'Nu aan het spreken',
    networking_topics: 'Netwerkonderwerpen',
    session_ended: 'Sessie beëindigd',
    find_next_partner: 'Vind volgende partner',
    find_next_group: 'Zoek volgende groep',
    partner_wasnt_ready: 'Partner was niet klaar',
    partner_wasnt_ready_description: 'Het lijkt erop dat de partner niet klaar was voor het gesprek. Laten we een nieuwe zoeken!',
    start_matching: 'Start met matchen'
  }
}
